import { render, staticRenderFns } from "./MatchHistory.vue?vue&type=template&id=ad5bff5e&scoped=true"
import script from "./MatchHistory.vue?vue&type=script&lang=js"
export * from "./MatchHistory.vue?vue&type=script&lang=js"
import style0 from "./MatchHistory.vue?vue&type=style&index=0&id=ad5bff5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5bff5e",
  null
  
)

export default component.exports